import { render, staticRenderFns } from "./ProfileMenuPopup.vue?vue&type=template&id=c13d439e"
import script from "./ProfileMenuPopup.vue?vue&type=script&lang=js"
export * from "./ProfileMenuPopup.vue?vue&type=script&lang=js"
import style0 from "./ProfileMenuPopup.vue?vue&type=style&index=0&id=c13d439e&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports